import { render, staticRenderFns } from "./BtnAddTables.vue?vue&type=template&id=652b8250&"
import script from "./BtnAddTables.vue?vue&type=script&lang=js&"
export * from "./BtnAddTables.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports